import linesLeftPM from '#app/assets/images/decorative/lines-left-pm.svg'
import linesRightPM from '#app/assets/images/decorative/lines-right-pm.svg'
import { CardImageTextExt } from '#app/components/ui/card-image-text-ext.tsx'
import { Tag } from '#app/components/ui/tag.tsx'

interface ProgramComponentsSectionProps {
	className?: string
}

export function ProgramComponentsSection({
	className,
}: ProgramComponentsSectionProps) {
	const components = [
		{
			image: '/img/programa-madre/taller-educativo.png',
			title: 'Taller educativo con estudiantes y docentes',
			description:
				'Un curso por escuela es seleccionado para participar. Se realiza una actividad lúdica y participativa, que incluye dinámicas grupales, reflexión colectiva y la participación del cuerpo docente.',
		},
		{
			image: '/img/programa-madre/manual-cambio-climatico.png',
			title: 'Material educativo exclusivo',
			description:
				'Manual de Cambio Climático: desarrollado por Asociación Valor Tres, donado a las bibliotecas escolares. Juego de Economía Circular: juego interactivo y didáctico para aprender jugando.',
		},
		{
			image: '/img/programa-madre/medicion-huella-carbono.png',
			title: 'Medición de Huella de Carbono',
			description:
				'A cargo de Netzefy, se realiza una evaluación personalizada de la huella de carbono del establecimiento educativo.',
		},
		{
			image: '/img/programa-madre/forestacion.png',
			title: 'Acciones de forestación',
			description:
				'Cada escuela participante que lo permita recibe cinco ejemplares de árboles nativos, seleccionados especialmente según la zona.',
		},
		{
			image: '/img/programa-madre/paneles-solares.png',
			title: 'Instalación de paneles solares',
			description:
				'Acompañamiento con un plan de eficiencia energética: Instalación de 30 paneles solares de 450W, Ahorro estimado del 40% al 60% del consumo energético, Reducción directa de emisiones de CO₂',
		},
	]

	return (
		<section className={`relative bg-white ${className || ''}`}>
			{/* Decorative background elements */}
			<div
				className="pointer-events-none absolute inset-0 overflow-hidden"
				aria-hidden="true"
			>
				{/* Left lines with gradient overlay */}
				<div className="absolute top-[-200px] left-[-333.98px] h-[1608.14px] w-[1666.46px]">
					<img
						src={linesLeftPM}
						alt=""
						className="drop-shadow-glow-brand h-full w-full object-contain"
					/>
				</div>

				{/* Right lines with gradient overlay */}
				<div className="absolute top-[-199.89px] left-[720.76px] h-[1442.20px] w-[1509.64px]">
					<img
						src={linesRightPM}
						alt=""
						className="drop-shadow-glow-brand h-full w-full object-contain"
					/>
				</div>
			</div>

			<div className="relative z-10 container mx-auto max-w-[1200px] px-[37.5px] py-16 md:px-4">
				<div className="flex flex-col gap-16 md:flex-row md:gap-16">
					{/* Left Column - Sticky Title */}
					<div className="md:sticky md:top-0 md:h-fit md:w-[568px] md:shrink-0 md:py-16">
						<div className="flex flex-col gap-16">
							{/* Tag */}
							<div>
								<Tag
									variant="secondary"
									appearance="solid"
									color="green"
									size="l"
									option="text-icon-left"
									leftIcon="configuration-01"
								>
									Componentes del programa
								</Tag>
							</div>

							{/* Title */}
							<h2 className="font-parkinsans text-txt-primary text-4xl leading-[70px] font-medium md:text-[56px]">
								¿En qué consiste?
							</h2>
						</div>
					</div>

					{/* Right Column - Component Cards */}
					<div className="flex flex-1 flex-col gap-8">
						{components.map((component, index) => (
							<CardImageTextExt
								key={index}
								layout="horizontal"
								state="default"
								showImage={true}
								image={component.image}
								imageAlt={component.title}
								showChip={false}
								showIcon={false}
								title={component.title}
								showDescription={true}
								description={component.description}
								showButton={false}
								showButton2={false}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

export default ProgramComponentsSection
